import React from "react";
import axios from "axios";
import './benefisciaryVerify.css';
import { connect } from "react-redux";
import history from "../../auth/history";
import FooterComponet from "../FooterComponent/FooterComponet";
import { v4 as uuidv4 } from 'uuid';
import BenefisciarySubDetails from "./BenefisciarySubDetails";
import { store } from "../../redux/store";
import { setBeneCustomerId, setBeneSubDetails, setBranchAddress, setIfscCode, setOtpResponse, setSelectedBankName, setSelectedBankId, setCreteOrderReq, setCreateOrderRes, setMoneyTransferProgress, setStatusEnqResponse, setTxnAmount, setTxnsurcharge, setTxntotalAmount, setBeneRegister } from './../../redux/misc-data/misc-data.action';
import HeaderCommon from './../HeaderComponent/HeadeCommon';
import moment from "moment";
import Menu from "../MenuComponent/Menu";
import { Link } from "react-router-dom";

const httpClient = axios.create();

class BenefisciaryVerification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            password: '',
            otpRef: '',
            message: '',
            errorMessage: '',
            otpNo: '',
            loader: true,
            beneverified: false,
            progress:''
        }
    }




    addBeneFisciary = () => {
        store.dispatch(setSelectedBankName(''));
        store.dispatch(setIfscCode(''));
        store.dispatch(setBranchAddress(''));
        store.dispatch(setSelectedBankId(''));

        setTimeout(() => {
            var addbeneficiaryBtn = document.getElementById('addbeneficiaryBtn');
        addbeneficiaryBtn.click();
        }, 200);
        
    }


    componentDidMount() {
        this.setState({
            loader: true
        })

        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }
        var addBenefisciaryRequest = this.props.benefisciaryRequest;
        var addBeneUrl = '/api/v1/dmt/beneficiary/add';
        const otpDetails = {
            mobile: this.props.selectSender.customer.mobile,
            type: 'ADD_DMT_BENEFICIARY',
            refNo: this.props.generateOtpResponse.otpDetails.refNo,
            otp: this.props.beneVerifyOtp
        }

        const request = {
            header: addBenefisciaryRequest.header,
            beneficiary: addBenefisciaryRequest.beneficiary,
            deviceInfo: this.props.deviceInfo,
            otp: otpDetails,
            customerId: this.props.selectSender.customer.id,
            doVerification: true,
            agentId: this.props.agentInfo.id
        }


        console.log('request::' + JSON.stringify(request));

        httpClient.post(addBeneUrl, request, { headers }
        ).then((response) => {
            this.setState({
                loader: false
            })
            console.log('register bene response' + JSON.stringify(response.data));
            if (response.data.response.msg == 'CONFIRM_BENEFICIARY') {
                store.dispatch(setBeneRegister(response.data));

                store.dispatch(setBeneCustomerId(response.data.beneficiaryId));
                this.setState({
                    beneverified: true
                })

            } else {
                this.setState({
                    beneverified: false
                })
                this.errorMessageCall(response.data.response.displayMsg);
            }
        }).catch(error => {
            this.setState({
                loader: false
            })
            this.errorMessageCall(error.message);
           
        });

    }
    componentWillUnmount() {
    }

    enterOtp = (event) => {
        event.preventDefault();
        this.setState({
            otpNo: event.target.value
        })
    }

    goToBeneSubDetails = (event) => {
        event.preventDefault();
        this.setState({
            progress: 'started'
        })

        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }
        var url = '/api/v1/dmt/beneficiary/activate/' + this.props.selectSender.customer.id + '/' + this.props.beneCustomerId;
        httpClient.post(url, {}, { headers }
        ).then((response) => {
            this.setState({
                progress: 'completed'
            })

            console.log('activate bene response' + JSON.stringify(response.data));
            if (response.data == true) {
               
                var beneficiaryDetailsBtn=document.getElementById('beneficiaryDetailsBtn');
                beneficiaryDetailsBtn.click();

            } else {
                this.errorMessageCall('error in activate benefisciary');
            }
        }).catch(error => {
            this.setState({
                progress: 'completed'
            })
            this.errorMessageCall(error.message);
            
        });
    }

    rejectBeneFisciary = (event) => {



        event.preventDefault();
        this.setState({
            progress: 'started'
        })

        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role':  this.props.clientRole
        }
        var url = '/api/v1/dmt/beneficiary/delete/' + this.props.selectSender.customer.id + '/' + this.props.beneCustomerId;
        httpClient.post(url, {}, { headers }
        ).then((response) => {
            this.setState({
                progress: 'completed'
            })

            console.log('delete bene response' + JSON.stringify(response.data));
            if (response.data == true) {
                store.dispatch(setSelectedBankName(''));
                store.dispatch(setIfscCode(''));
                store.dispatch(setBranchAddress(''));
                store.dispatch(setSelectedBankId(''));


                var addbeneficiaryBtn = document.getElementById('addbeneficiaryBtn');
                addbeneficiaryBtn.click();

            } else {
                this.errorMessageCall('error in reject benefisciary');
            }
        }).catch(error => {
            this.setState({
                progress: 'completed'
            })
            this.errorMessageCall(error.message);
            
        });

    }
    errorMessageCall = (error) => {
        this.setState({
            errorMessage: error
        })
    }



    render() {
        return (

            <div>
                <HeaderCommon />
                <Menu />
                <div class="main">
                    <div class="right-side">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-12">
                                    <div class="card-b" id="rightdiv">
                                        <div id="recenttxn">
                                            <div class="head">
                                                <h3>Beneficiary Details</h3>
                                                <div class="headbtn">
                                                    <Link to='/dmt'>
                                                        <button class="dbbtn" type="button">Back</button>
                                                    </Link>
                                                    <Link to='/add-beneficiary'>
                                                        <button id='addbeneficiaryBtn' hidden={true}></button>
                                                    </Link>
                                                    <Link to='/beneficiary-details'>
                                                        <button id='beneficiaryDetailsBtn' hidden={true}></button>
                                                    </Link>

                                                </div>
                                            </div>

                                            <div class="status">
                                                {this.state.loader == true &&
                                                    <h3 class="pending" id="bnrun">Beneficiary Confirmation...</h3>
                                                }
                                                {this.state.loader == false &&
                                                    this.state.beneverified == true &&
                                                    <h3 class="success" id="bndone">Beneficiary Confirmed</h3>
                                                }

                                                {this.state.loader == false &&
                                                    this.state.beneverified != true &&
                                                    <h3 class="failed" id="bndone">Beneficiary Failed!</h3>
                                                }

                                            </div>
                                            <div class="benereviewcard">
                                                <div class="row">
                                                    <div class="col-12 col-md-4">
                                                        <div class="benedtl">
                                                            {/* <img src="images/sbi-bank.png" alt=""> */}
                                                            <h4>{this.props.beneSubDetails != null && this.props.beneSubDetails.benefisciaryName}</h4>
                                                            <p>{this.props.beneSubDetails != null && this.props.beneSubDetails.bankName}</p>
                                                        </div>
                                                    </div>

                                                    <div class="col-12 col-sm-6 col-md-4">
                                                        <div class="benedtl">
                                                            <h5>Account Number</h5>
                                                            <p>{this.props.beneSubDetails != null && this.props.beneSubDetails.accountNumber}</p>
                                                        </div>
                                                    </div>

                                                    <div class="col-6 col-sm-3 col-md-2">
                                                        <div class="benedtl">
                                                            <h5>Mobile Number</h5>
                                                            <p>{this.props.beneSubDetails != null && this.props.beneSubDetails.benefisciaryMobile}</p>
                                                        </div>
                                                    </div>

                                                    <div class="col-6 col-sm-3 col-md-2">
                                                        <div class="benedtl rtxt">
                                                            <h5>IFSC Code</h5>
                                                            <p>{this.props.beneSubDetails != null && this.props.beneSubDetails.ifscCode}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {this.state.loader == false &&
                                            this.state.beneverified == true &&
                                            <div>
                                                <div class="txthead">
                                                    <h4>Beneficiary name at Bank</h4>
                                                </div>

                                                <div class="benereviewcard">
                                                    <div class="row">
                                                        <div class="col-12 col-md-4">
                                                            <div class="benedtl">
                                                                {/* <img src="images/sbi-bank.png" alt=""> */}
                                                                {/* <h4>{this.props.beneSubDetails!=null &&this.props.beneSubDetails.benefisciaryName}</h4>
                                        <p>{this.props.beneSubDetails!=null &&this.props.beneSubDetails.bankName}</p> */}
                                                                <h4>{this.props.beneRegisterResponse != '' && this.props.beneRegisterResponse.beneficiaryName}</h4>
                                                                <p>{this.props.beneSubDetails != null && this.props.beneSubDetails.bankName}</p>

                                                            </div>
                                                        </div>

                                                        <div class="col-12 col-sm-6 col-md-4">
                                                            <div class="benedtl">
                                                                <h5>Account Number</h5>
                                                                <p>{this.props.beneSubDetails != null && this.props.beneSubDetails.accountNumber}</p>
                                                            </div>
                                                        </div>

                                                        <div class="col-12"><hr /></div>

                                                        <div class="col-12 col-md-4">
                                                            <div class="benedtl">
                                                                <h5>Verification Amount</h5>
                                                                <p>₹ 5.00</p>
                                                            </div>
                                                        </div>

                                                        <div class="col-6 col-sm-6 col-md-4">
                                                            <div class="benedtl">
                                                                <h5>Reference ID</h5>
                                                                <p>{this.props.beneCustomerId}</p>
                                                            </div>
                                                        </div>

                                                        <div class="col-6 col-sm-6 col-md-4">
                                                            <div class="benedtl rtxt">
                                                                <h5>Date & Time</h5>
                                                                <p>{moment().format("DD-MM-YYYY HH:mm:ss")}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="dashform">
                                                    <button type="button" class="btn btn-primary" onClick={this.goToBeneSubDetails} disabled={this.state.progress=='started'?true:false}>Add Now</button>

                                                    <button type="button" class="btn btn-reset" onClick={this.rejectBeneFisciary} disabled={this.state.progress=='started'?true:false}>Reject</button>
                                                </div>
                                            </div>
                                        }

                                        {this.state.loader == false &&
                                            this.state.beneverified != true &&
                                            <div class="dashform">
                                                <button type="button" class="btn btn-reset" onClick={this.addBeneFisciary}
                                                >Retry</button>
                                            </div>
                                        }

                                        {this.state.loader == false &&
                                            this.state.errorMessage != '' &&
                                            <div class='valid-error'>
                                                {this.state.errorMessage}
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <FooterComponet />
            </div>

        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage },
        miscReduce: { phone, benefisciaryRequest, addSenderRequest, ifscCode,
            generateOtpResponse, agentInfo, token,clientRole, selectSender, beneSubDetails,
            createOrderStatusResponse, beneVerifyOtp, beneCustomerId, beneRegisterResponse } }
) => ({
    errorMessage, loginErrorMessage, phone, benefisciaryRequest, addSenderRequest,
    ifscCode, generateOtpResponse, agentInfo, token, clientRole, selectSender, beneSubDetails,
    createOrderStatusResponse, beneVerifyOtp, beneCustomerId, beneRegisterResponse
});

export default connect(mapStateToProps, null)(BenefisciaryVerification);
